import { Component, Input } from '@angular/core';
import { TrackToolStep } from '@analytics/models';
import type { InnogyComponentRendering } from '@core/jss-models';
import {
  uppercaseConverter,
  AutocompleteDirective,
  IsInvalidPipe,
} from '@innogy/utils-deprecated';
import { FormGroupState } from 'ngrx-forms';
import { NgTemplateOutlet } from '@angular/common';

import type {
  PostalAddressFormRendering,
  PostalAddressFormValues,
} from './model/postal-address-form.model';
import { PostalAddressFormContent } from './model/postal-address-form.model';
import type { FormAddress } from '../address-form/state/address-form.types';
import { TextComponent } from '../text/text.component';
import { NumberComponent } from '../number/number.component';
import { InputErrorComponent } from '../input-error/input-error.component';

@Component({
  selector: 'wl-postal-address-form[rendering][content][trackStep]',
  templateUrl: './postal-address-form.component.html',
  standalone: true,
  imports: [
    NgTemplateOutlet,
    TextComponent,
    AutocompleteDirective,
    IsInvalidPipe,
    NumberComponent,
    InputErrorComponent,
  ],
})
export class PostalAddressFormComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering & {
    fields: PostalAddressFormRendering;
  };
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState!: FormGroupState<PostalAddressFormValues | FormAddress>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content!: PostalAddressFormContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabels = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;

  public readonly _uppercaseConverter = uppercaseConverter;

  get automationId(): string {
    return this.formState.id;
  }
}
